export default __webpack_public_path__ + "static/media/Instagram.75ccee32.svg";